import type { Server, UserInfo } from '@forest/paywall-core'

// Production splits by `userInfo.server` (`global` vs `china`). Staging and
// dev each have a single cluster, so the `dev` and `staging` cells hold the
// same id the campaign uses on those clusters.
export const CAMPAIGN_ITEM_TYPE_ID_BY_SERVER: Record<Server, number> = {
  dev: 230,
  staging: 230,
  global: 239,
  china: 228,
}

export function getCampaignItemTypeId(userInfo: UserInfo): number {
  return CAMPAIGN_ITEM_TYPE_ID_BY_SERVER[userInfo.server]
}
